import React, { useEffect } from "react";
import { Row, Col, Breadcrumb } from "react-bootstrap";
import * as myApi from "../components/Api";
import DashboardContent from "../components/Dashboard/DashboardContent";

const Dashboard = () => {

    useEffect(() => {
        // Redirect peserta users to paper list
        const user = myApi.getUser();
        if (!user || user.role !== 'admin') {
            window.location.href = "/paper/list/";
        }
    }, []);

    return (
        <div>
            <Row>
                <Col className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                    <h3>Dashboard</h3>
                    <Breadcrumb className="breadcrumb-page-list align-items-center mb-0 lh-1">
                        <Breadcrumb.Item href="/dashboard/" active>
                            <div className="d-flex align-items-center text-decoration-none">
                                <i className="ri-home-4-line fs-18 text-primary me-1"></i>
                                <span className="text-secondary fw-medium hover">Dashboard</span>
                            </div>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <DashboardContent />
            </Row>
        </div>
    );
};

export default Dashboard;